/*
=========================================================
* Material Kit 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/
import { useEffect, useState } from "react";

// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Divider from "@mui/material/Divider";

// Material Kit 2 React components
import MKBox from "components/MKBox";

// Material Kit 2 React examples
import DefaultCounterCard from "components/Cards/CounterCards/DefaultCounterCard";
import { useTranslation } from "react-i18next";

import axios from "axios";

function MainFeatures() {
  const { t } = useTranslation();
  const [count, setCount] = useState(0);

  useEffect(() => {
    const getCount = async () => {
      const amenitiesCount = await axios.get(`${process.env.REACT_APP_BACKEND}/amenities/count`);
      setCount(amenitiesCount.data);
    };

    getCount();
  }, []);

  return (
    <MKBox component="section" py={3}>
      <Container>
        <Grid container item xs={12} lg={9} sx={{ mx: "auto" }}>
          <Grid item xs={12} md={4}>
            <DefaultCounterCard
              count={5}
              title={t("Bedrooms")}
              description={t("sleeps up to 10 people comfortably")}
            />
          </Grid>
          <Grid item xs={12} md={4} display="flex">
            <Divider orientation="vertical" sx={{ display: { xs: "none", md: "block" }, mx: 0 }} />
            <DefaultCounterCard
              count={5}
              suffix="+"
              title={t("Bathrooms")}
              description={t("Complete with poolside bathroom")}
            />
            <Divider orientation="vertical" sx={{ display: { xs: "none", md: "block" }, ml: 0 }} />
          </Grid>
          <Grid item xs={12} md={4}>
            <DefaultCounterCard
              count={count}
              suffix="+"
              title={t("Amenities")}
              description={t("From a washer and dryer to wifi, it's included.")}
            />
          </Grid>
        </Grid>
      </Container>
    </MKBox>
  );
}

export default MainFeatures;
